<ui-content-header
	type="page"
	title="Clients"
	[testHook]="testHooks.ClientsContentHeader"
>
	<app-party-clients-header
		title-action
		[isClient]="true"
		[primaryContact]="matterClients?.length === 0"
		[matterFileType]="matterFileType"
		[addButtonText]="buttonText"
	></app-party-clients-header>

	<div *ngIf="showTreefort" actions class="flex items-center gap-2">
		<ui-button
			icon="puzzle"
			preset="MEDIUM_EMPHASIS"
			(click)="verify()"
			[label]="'Send IDV Request'"
			[testHook]="testHooks.SendIdvButton"
		/>
		<div class="flex justify-end">
			<img
				class="h-5 w-20"
				src="/assets/images/integrations/treefort-logo.svg"
				alt="Treefort"
			/>
		</div>
	</div>
</ui-content-header>

<div [grid] class="@container">
	<div class="flex flex-col gap-4 @3xl:col-span-6 @6xl:col-span-5 col-span-12">
		<ng-container *ngIf="matterClients.length > 0; else noClients">
			<div *ngFor="let client of matterClients; trackBy: trackClient">
				<app-client-tab
					[client]="client"
					[clientType]="clientType"
					data-intercom-target="parties-client-card"
				></app-client-tab>
			</div>
		</ng-container>

		<ng-template #noClients>
			<div
				class="flex flex-col gap-y-4 bg-white rounded-xl border border-gray-200 px-8 pt-20"
			>
				<div class="text-center flex flex-col gap-y-1 pb-20">
					<h5 class="h5">No clients added yet.</h5>
				</div>
			</div>
		</ng-template>

		<ui-section
			title="Details"
			*ngIf="matterFileType === matterFileTypes.PURCHASE"
			[testHook]="testHooks.DetailsSection"
		>
			<div section-content class="flex flex-col gap-2">
				<app-checkbox
					type="clear"
					[ngModel]="purchaserResideInProperty"
					(ngModelChange)="setPurchasersResiding($event)"
					class="mt-2"
					[testHook]="testHooks.PurchaserResideInPropertyCheckbox"
					>Purchasers will be residing at subject property</app-checkbox
				>
				<app-party-capacity
					label="Capacity of ownership"
					class="mt-5 flex-1 w-full"
				></app-party-capacity>
			</div>
		</ui-section>
	</div>

	<div class="flex gap-4 flex-col @3xl:col-span-6 @6xl:col-span-7 col-span-12">
		@if (isClientIntakeEnabled_()) {
			<ui-section
				title="Client Intake"
				class="[&>div]:overflow-visible"
				[testHook]="testHooks.ClientIntakeSection"
			>
				<div actions>
					<app-client-intake-card-header />
				</div>

				<app-client-intake-request section-content></app-client-intake-request>
			</ui-section>
		}

		<ui-section
			title="Client Brokerage"
			class="[&>div]:overflow-visible"
			[testHook]="testHooks.ClientBrokerageSection"
		>
			<app-brokerage section-content [isClientBrokerage]="true"></app-brokerage>
		</ui-section>

		<app-file-salutations section-content></app-file-salutations>
	</div>
</div>
